import { u as s } from "./focusable-selectors-BazEJmRZ.js";
const o = (e) => e.querySelector(s), r = (e) => e.assignedElements().find((t) => t.matches(s));
export {
  r as a,
  o as f
};
//# sourceMappingURL=first-focusable-in-C_FjNeTy.js.map
